import classNames from "classnames";
import { Glyph } from "../../types";
import styles from "./Check.module.css";
import Icon from "./Icon";

type CheckProps = {
  icon: Glyph;
  color?: "red" | "green" | "blue" | "yellow";
  obscured?: boolean;
};

export const Check = ({ icon, color, obscured }: CheckProps) => (
  <Icon
    glyph={icon}
    className={classNames(
      styles.icon,
      {
        [styles.green]: color === "green",
        [styles.red]: color === "red",
        [styles.blue]: color === "blue",
        [styles.yellow]: color === "yellow",
      },
      !!obscured && styles.obscured
    )}
  />
);
